import HomeAboutUsComponent from "../../components/home/aboutUs/HomePageAboutUsComponent";
import HomePageBannerComponent from "../../components/home/banner/HomePageBannerComponent";
import HomePageCategoryListComponent from "../../components/home/categories/HomePageCategoryListComponent";

import "../../styles/pages/home/homePageComponent.scss";

export const HomePageComponent = () => {
  return (
    <div className="homePageContainer">
      <HomePageBannerComponent />
      <HomePageCategoryListComponent />
      <HomeAboutUsComponent />
    </div>
  );
};

export default HomePageComponent;
